import React from "react";

function BS4_JS_Button() {
  return (
    <div>
      <h1>BS4_JS_Button Component</h1>
      <p>This is the BS4_JS_Button tutorial page content.</p>
    </div>
  );
}

export default BS4_JS_Button;
